/**
 * @generated SignedSource<<04ad8d972907423a728b8760d91e57ce>>
 * @relayHash 9ddcbf0a03b8df30b230d37eb051e105
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ddcbf0a03b8df30b230d37eb051e105

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocExchangeOperation = "CANCEL_RECOMMENDATION" | "CREATE_RECOMMENDATION" | "GET_ANAMNESIS_INFO_SCHEMAS" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeOutcome = "CANCELLED" | "FAILED" | "PENDING" | "RESPONDED" | "TIMED_OUT" | "TOKEN_UNAVAILABLE";
export type de_BetterDocRecommendationDelivery = "MSN" | "PMN";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocTestCaseScenario = "MSN" | "MSN_WITH_SECOND_OPINION" | "PMN";
export type betterDocLookupQuery$variables = {
  identifier: string;
};
export type betterDocLookupQuery$data = {
  readonly de_betterDocLookup: {
    readonly exchange: {
      readonly createdBy: string;
      readonly durationMilliseconds: number | null;
      readonly exchangeId: number;
      readonly failureKind: string | null;
      readonly hasUnexpectedResponse: boolean;
      readonly httpMethod: string;
      readonly isTestCase: boolean;
      readonly operation: de_BetterDocExchangeOperation;
      readonly outcome: de_BetterDocExchangeOutcome;
      readonly requestUri: any;
      readonly responseStatusCode: number | null;
      readonly startedAt: string;
    } | null;
    readonly sessions: ReadonlyArray<{
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly insuranceCountry: Country | null;
      readonly isTestCase: boolean;
      readonly partnerPatientId: string;
      readonly partnerSessionId: string;
      readonly progressNoteId: number | null;
      readonly recommendationDelivery: de_BetterDocRecommendationDelivery | null;
      readonly sessionId: number;
      readonly testCaseScenario: de_BetterDocTestCaseScenario | null;
    }>;
  };
};
export type betterDocLookupQuery = {
  response: betterDocLookupQuery$data;
  variables: betterDocLookupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTestCase",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "identifier",
        "variableName": "identifier"
      }
    ],
    "concreteType": "de_BetterDocLookupResult",
    "kind": "LinkedField",
    "name": "de_betterDocLookup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocSessionSummary",
        "kind": "LinkedField",
        "name": "sessions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "testCaseScenario",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationDelivery",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betterDocState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocExchangeSummary",
        "kind": "LinkedField",
        "name": "exchange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "exchangeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "operation",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "httpMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestUri",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnexpectedResponse",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatusCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationMilliseconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureKind",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocLookupQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocLookupQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "9ddcbf0a03b8df30b230d37eb051e105",
    "metadata": {},
    "name": "betterDocLookupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0f7bca6c85defdd02224fa6456358a9d";

export default node;
